"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isThumbnailBlurred = void 0;
var isThumbnailBlurred = function (user) {
    var _a;
    return ((_a = user.ageVerificationRules) === null || _a === void 0 ? void 0 : _a.requiresAgeConfirmation) && (!user.isAuthenticated || user.isFreemium);
};
exports.isThumbnailBlurred = isThumbnailBlurred;
//# sourceMappingURL=UserService.js.map